import { AGE_RATINGS_SYSTEMS_TO_VALUES_KEYS_MAP } from '@sitegen/common/constants/age-ratings';

export const isLegalTaglineEnabled = (USKRating: string, countryCode: string) =>
    USKRating === AGE_RATINGS_SYSTEMS_TO_VALUES_KEYS_MAP.USK.USK_18 && countryCode === 'DE';
